// https://getbootstrap.com/docs/5.0/components/button-group/

import type { IChildrenProps } from '../definitions'

import './ButtonGroup.css'

interface IProps extends IChildrenProps {
  readonly alignment?: 'vertical' | 'horizontal'
}

/**
 * Egy BS ButtonGroup factory-ja.
 * @param props - JSX props {@link IProps}.
 */
export default function ButtonGroup (props: IProps): HTMLElement {
  const { alignment = 'horiontal', children } = props

  const group: HTMLElement = (
    <div
      className={ `btn-group${ alignment === 'vertical' ? '-vertical' : '' }` }
      role="group"
    >
      { children }
    </div>
  )

  return group
}
